interface UnlockOverlayProps {
  onUnlock: (e: React.MouseEvent) => void;
}

export function UnlockOverlay({ onUnlock }: UnlockOverlayProps) {
  return (
    <div
      className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-black/95"
      style={{ zIndex: 9999 }}
    >
      <div className="text-center max-w-2xl px-6">
        <div className="font-display text-3xl md:text-4xl text-white mb-6">
          SWANSONG RADIO
        </div>

        <div className="bg-black/60 border border-white/10 rounded-lg p-6 mb-8">
          <p className="text-white/90 leading-relaxed mb-4">
            This site and its contents, including all music, are works of <span className="text-red-400 font-semibold">dark satire</span>.
          </p>
          <p className="text-white/70 text-sm leading-relaxed">
            All characters and scenarios depicted are <span className="text-white/90">not based on any real individuals</span>, but rather serve as exaggerated representations of the worst facets of humanity.
          </p>
        </div>

        <button
          onClick={onUnlock}
          className="font-mono text-sm tracking-widest text-white uppercase px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/30 hover:border-white/50 transition-all cursor-pointer rounded"
        >
          Click here if you agree to the terms
        </button>
      </div>
    </div>
  );
}
